import { render, staticRenderFns } from "./WtDmLayout.vue?vue&type=template&id=1a4e45f3&scoped=true&lang=pug&"
import script from "./WtDmLayout.vue?vue&type=script&lang=ts&"
export * from "./WtDmLayout.vue?vue&type=script&lang=ts&"
import style0 from "./WtDmLayout.vue?vue&type=style&index=0&id=1a4e45f3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4e45f3",
  null
  
)

component.options.__file = "WtDmLayout.vue"
export default component.exports